import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { base } from "../base.js";
import "./App.css";
import Board from "./Board.js";
import Home from "./Home.js";
import Finished from "./Finished.js";
import ExpireRetro from "./ExpireRetro.js";
import Settings from "./Settings.js";
import Marketing from "./Marketing.js";
import PrivacyAndTos from "./PrivacyAndTos.js";
import firebase from "firebase";
import ReactGA from "react-ga";

ReactGA.initialize("UA-63802547-3");

const sendUpgradeEmail = firebase.functions().httpsCallable("sendUpgradeEmail");
const sendSummaryEmails = firebase
  .functions()
  .httpsCallable("sendSummaryEmails");

const expirationLength = hoursToMilliseconds(18);

function hoursToMilliseconds(hours) {
  return hours * 60 * 60 * 1000;
}

class App extends Component {
  constructor() {
    super();

    this.state = {
      redirect: false,
      user: null,
      currentRetroSession: null,
      retroSessions: [],
      members: [],
      settings: {
        teamName: "",
        frequency: "weekly",
        day: 5,
        time: "16:30",
        freeRetros: 4
      },
      dataLoaded: {
        retroSessionsLoaded: false,
        currentRetroSessionLoaded: false,
        settingsLoaded: false,
        paymentLoaded: false,
        membersLoaded: false
      },
      auth: {
        loading: true
      }
    };
  }

  componentWillMount = () => {
    firebase.auth().onAuthStateChanged(fbUser => {
      // console.log("fbUser:", fbUser);

      var user = null;
      if (fbUser) {
        user = {
          email: fbUser.email,
          displayName: fbUser.displayName,
          uid: fbUser.uid,
          creationTime: fbUser.metadata.creationTime,
          lastSignInTime: fbUser.metadata.lastSignInTime,
          photoURL: fbUser.photoURL
        };

        this.setState(
          {
            user: user,
            auth: {
              loading: false
            }
          },
          () => {
            this.identifyUser();
            window.analytics.track("Logs In");

            base.syncState(`${this.state.user.uid}/retroSessions/`, {
              context: this,
              state: "retroSessions",
              asArray: true,
              then() {
                const dataLoaded = this.state.dataLoaded;
                dataLoaded.retroSessionsLoaded = true;
                this.setState({
                  dataLoaded
                });
              }
            });
            base.syncState(`${this.state.user.uid}/currentRetroSession/`, {
              context: this,
              state: "currentRetroSession",
              defaultValue: null,
              then() {
                const dataLoaded = this.state.dataLoaded;
                dataLoaded.currentRetroSessionLoaded = true;
                this.setState({
                  dataLoaded
                });
              }
            });
            base.syncState(`${this.state.user.uid}/settings/`, {
              context: this,
              state: "settings",
              defaultValue: {
                teamName: "",
                frequency: "weekly",
                day: 5,
                time: "16:30",
                freeRetros: 4
              },
              then() {
                const dataLoaded = this.state.dataLoaded;
                dataLoaded.settingsLoaded = true;
                this.setState({
                  dataLoaded
                });
              }
            });
            base.syncState(`${this.state.user.uid}/payment/`, {
              context: this,
              state: "payment",
              then() {
                const dataLoaded = this.state.dataLoaded;
                dataLoaded.paymentLoaded = true;
                this.setState({
                  dataLoaded
                });
              }
            });
            base.syncState(`${this.state.user.uid}/members/`, {
              context: this,
              state: "members",
              asArray: true,
              then() {
                const dataLoaded = this.state.dataLoaded;
                dataLoaded.membersLoaded = true;
                this.setState({
                  dataLoaded
                });
              }
            });
          }
        );
      } else {
        this.setState({
          redirect: true,
          auth: {
            loading: false
          }
        });
      }
    });
  };

  componentDidUpdate = () => {
    this.identifyUser();
  };

  allDataLoaded = () => {
    const retroSessionsLoaded = this.state.dataLoaded.retroSessionsLoaded;
    const currentRetroSessionLoaded = this.state.dataLoaded
      .currentRetroSessionLoaded;
    const settingsLoaded = this.state.dataLoaded.settingsLoaded;
    const paymentLoaded = this.state.dataLoaded.paymentLoaded;
    const membersLoaded = this.state.dataLoaded.membersLoaded;

    if (
      retroSessionsLoaded &&
      currentRetroSessionLoaded &&
      settingsLoaded &&
      paymentLoaded &&
      membersLoaded
    ) {
      return true;
    } else {
      return false;
    }
  };

  identifyUser = () => {
    if (this.state.user && this.allDataLoaded()) {
      let user = this.state.user;
      let settings = this.state.settings;
      let membersCount = this.state.members.length;
      let retroSessions = this.state.retroSessions;
      let payment = this.state.payment;

      window.analytics.identify(user.uid, {
        email: user.email,
        name: user.displayName,
        created: user.creationTime,
        teamName: settings.teamName,
        frequency: settings.frequency,
        day: settings.day,
        time: settings.time,
        freeRetros: settings.freeRetros,
        membersCount: membersCount,
        retroSessionsCount: retroSessions ? retroSessions.length : null,
        stripeCustomerID: payment ? payment.stripeCustomerID : null,
        last4: payment ? payment.last4 : null,
        activeSubscription: payment
          ? Boolean(payment.activeSubscription)
          : null,
        totalConcernsCompleted: retroSessions[0]
          ? retroSessions[0].totalConcernsCompleted
          : null
      });
    }
  };

  startRetro = () => {
    if (this.state.currentRetroSession) {
      window.analytics.track("Resumes Retro Session");
      return true;
    }

    const currentTime = Date.now();
    const currentRetroSession = {
      startTime: currentTime,
      endTime: null,
      concernsAdded: 0,
      concernsCompleted: 0,
      kudosGiven: 0
    };

    this.setState({
      currentRetroSession: currentRetroSession
    });
    window.analytics.track("Starts New Retro Session");
  };

  deleteRetro = () => {
    if (this.state.currentRetroSession) {
      this.setState({
        currentRetroSession: null
      });
    }

    window.analytics.track("Deletes Retro Session");
  };

  commitUpdatedKudosConcernsCount = updatedField => {
    if (!this.state.currentRetroSession) {
      return false;
    }

    const currentRetroSession = { ...this.state.currentRetroSession };
    currentRetroSession[updatedField] = currentRetroSession[updatedField] + 1;

    this.setState({
      currentRetroSession: currentRetroSession
    });
  };

  commitFinishedRetro = (
    concernsCompleted,
    totalConcernsCompleted,
    sendEmails,
    expired = false
  ) => {
    if (!this.state.currentRetroSession) {
      console.error("there is no current retro session");
      return false;
    }

    var currentRetroSession = this.state.currentRetroSession;
    currentRetroSession.endTime = Date.now();
    currentRetroSession.concernsCompleted = concernsCompleted;
    currentRetroSession.totalConcernsCompleted = totalConcernsCompleted;

    var retroSessions = [...this.state.retroSessions];
    retroSessions.unshift(this.state.currentRetroSession);

    currentRetroSession = null;

    this.setState(
      {
        retroSessions: retroSessions,
        currentRetroSession: currentRetroSession
      },
      () => {
        if (sendEmails) {
          sendSummaryEmails();
        }
      }
    );

    let finishedRetroSession = retroSessions[0];
    window.analytics.track("Finishes Retro Session", {
      retroStartTime: finishedRetroSession.startTime,
      retroEndTime: finishedRetroSession.endTime,
      concernsAdded: finishedRetroSession.concernsAdded,
      concernsCompleted: finishedRetroSession.concernsCompleted,
      kudosGiven: finishedRetroSession.kudosGiven,
      expired: expired,
      sendEmails: sendEmails
    });
  };

  checkRetroAge = () => {
    if (this.state.currentRetroSession) {
      const startTime = this.state.currentRetroSession.startTime;
      const currentTime = Date.now();

      return currentTime - startTime > expirationLength;
    } else {
      return false;
    }
  };

  commitUpdatedTeamName = updatedTeamName => {
    const settings = { ...this.state.settings };
    settings.teamName = updatedTeamName;

    this.setState({
      settings: settings
    });
  };

  commitUpdatedSettings = (updatedField, updatedValue) => {
    const settings = { ...this.state.settings };
    settings[updatedField] = updatedValue;

    this.setState({
      settings: settings
    });
  };

  decrementFreeRetros = () => {
    if (this.state.settings.freeRetros === 1) {
      sendUpgradeEmail(this.state.user);
    }

    const freeRetros = this.state.settings.freeRetros;
    const decrementedValue = freeRetros - 1;
    this.commitUpdatedSettings("freeRetros", decrementedValue);
  };

  commitNewMember = (nameValue, emailValue, id) => {
    if (!emailValue) {
      console.error("No email was provided");
      return false;
    }

    const members = [...this.state.members];

    for (let member of members) {
      if (member.email === emailValue) {
        console.error("This email already exists");
        return false;
      }
    }

    members.push({
      name: nameValue,
      email: emailValue,
      id: id
    });

    this.setState({
      members: members
    });

    window.analytics.track("Adds New Member", {
      memberName: nameValue,
      memberEmail: emailValue,
      memberId: id
    });
  };

  render() {
    if (this.checkRetroAge()) {
      return (
        <ExpireRetro
          commitFinishedRetro={this.commitFinishedRetro}
          user={this.state.user}
        />
      );
    }

    return (
      <div className="app-container">
        {this.state.auth.loading ? null : (
          <BrowserRouter>
            <div>
              <Switch>
                <Route
                  exact
                  path="/"
                  render={() => {
                    if (!this.state.redirect) {
                      return (
                        <Home
                          startRetro={this.startRetro}
                          currentRetroSession={this.state.currentRetroSession}
                          retroSessions={this.state.retroSessions}
                          user={this.state.user}
                          freeRetros={this.state.settings.freeRetros}
                          payment={this.state.payment}
                          settings={this.state.settings}
                          decrementFreeRetros={this.decrementFreeRetros}
                          allDataLoaded={this.allDataLoaded()}
                        />
                      );
                    } else {
                      return <Marketing />;
                    }
                  }}
                />
                <Route
                  exact
                  path="/board/"
                  render={() => {
                    if (
                      !this.state.redirect &&
                      this.state.currentRetroSession
                    ) {
                      return (
                        <Board
                          commitFinishedRetro={this.commitFinishedRetro}
                          deleteRetro={this.deleteRetro}
                          user={this.state.user}
                          members={this.state.members}
                          commitNewMember={this.commitNewMember}
                          kudosGiven={this.state.currentRetroSession.kudosGiven}
                          commitUpdatedKudosConcernsCount={
                            this.commitUpdatedKudosConcernsCount
                          }
                          freeRetros={this.state.settings.freeRetros}
                          payment={this.state.payment}
                          retroSessionsCount={this.state.retroSessions.length}
                        />
                      );
                    } else {
                      return <Redirect to="/" />;
                    }
                  }}
                />
                <Route
                  exact
                  path="/finished/"
                  render={() => {
                    if (
                      !this.state.redirect &&
                      this.state.retroSessions &&
                      this.state.retroSessions.length > 0
                    ) {
                      return (
                        <Finished
                          retroSessions={this.state.retroSessions}
                          user={this.state.user}
                          settings={this.state.settings}
                          commitUpdatedSettings={this.commitUpdatedSettings}
                          freeRetros={this.state.settings.freeRetros}
                          payment={this.state.payment}
                        />
                      );
                    } else {
                      return <Redirect to="/" />;
                    }
                  }}
                />
                <Route
                  exact
                  path="/settings/"
                  render={() => {
                    if (!this.state.redirect) {
                      return (
                        <Settings
                          settings={this.state.settings}
                          payment={this.state.payment}
                          commitUpdatedSettings={this.commitUpdatedSettings}
                          history={this.props.history}
                          user={this.state.user}
                        />
                      );
                    } else {
                      return <Redirect to="/" />;
                    }
                  }}
                />
                <Route
                  exact
                  path="/privacy-tos/"
                  render={() => {
                    return <PrivacyAndTos />;
                  }}
                />
              </Switch>
            </div>
          </BrowserRouter>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js